import { NavLink } from "react-router-dom";
import Web3 from "web3";
import { useLanguage } from "../LanguageContext";
import translation from "../Translations/translation.json";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Navbar.css";
import { Modal, Button, Dropdown } from "react-bootstrap";

const Navbar = () => {
  const [account, setAccount] = useState(null);
  const [web3, setWeb3] = useState(null);
  const [network, setNetwork] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const ETHW_PARAMS = {
    chainId: "0x2711", // 10001 in hex
    chainName: "ETHW-mainnet",
    nativeCurrency: {
      name: "EthereumPoW",
      symbol: "ETHW",
      decimals: 18,
    },
    rpcUrls: ["https://mainnet.ethereumpow.org"],
    blockExplorerUrls: ["https://mainnet.ethwscan.com"],
  };

  useEffect(() => {
    const storedAccount = sessionStorage.getItem("account");
    const storedNetwork = sessionStorage.getItem("network");

    if (storedAccount && storedNetwork) {
      setAccount(storedAccount);
      setNetwork(storedNetwork);
    }
  }, []);

  // Check if ETHW is active
  const checkNetwork = async () => {
    try {
      const chainId = await window.ethereum.request({ method: "eth_chainId" });
      return chainId === ETHW_PARAMS.chainId;
    } catch {
      return false;
    }
  };

  const handleConnectMetamask = async () => {
    // First check if MetaMask is installed
    if (!window.ethereum) {
      toast.error(`${translate("metamaskNotInstalledPleaseInstall")}`);
      return;
    }

    // Check ETHW network
    const isCorrectNetwork = await checkNetwork();
    if (!isCorrectNetwork) {
      setShowModal(true); // show ETHW modal
      return;
    }

    // Proceed to connect
    connectWallet();
  };

  // Actually connect wallet once ETHW is active
  const connectWallet = async () => {
    if (typeof window.ethereum === "undefined") {
      // No MetaMask
      toast.error(`${translate("metamaskNotDetected")}`);
      return;
    }

    try {
      const web3 = new Web3(window.ethereum);

      // ask user to connect
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });

      setAccount(accounts[0]);
      const networkId = await web3.eth.net.getId();
      // console.log("Network ID:", networkId);
      setNetwork(networkId);
      sessionStorage.setItem("account", accounts[0]);
      sessionStorage.setItem("network", networkId);
      toast.success(`${translate("metamaskConnected")}`);
    } catch (err) {
      console.error(err);
      toast.error(`${translate("connectionRejected")}`);
    }
  };

  useEffect(() => {
    if (typeof window.ethereum === "undefined") {
      toast.error(`${translate("metamaskNotInstalledPleaseInstall")}`);
    }
  }, []);

  // Add ETHW network to MetaMask
  const handleAddNetwork = async () => {
    try {
      await window.ethereum.request({
        method: "wallet_addEthereumChain",
        params: [ETHW_PARAMS],
      });
      toast.success(`${translate("ethwAdded")}`);
      setShowModal(false);
    } catch (err) {
      toast.error(`${translate("ethwAddFailed")}`);
    }
  };

  const shortenAddress = (address) =>
    address ? `${address.slice(0, 5)}...${address.slice(-5)}` : "";

  const { toggleLanguage, language } = useLanguage();
  const getLanguageLabel = (lang) => {
    switch (lang) {
      case "en":
        return "English";
      case "zh":
        return "中文";
      case "vn":
        return "Việt";
      case "ja":
        return "日本語"; // Japanese
      case "ko":
        return "한국어"; // Korean (Hangul)
      default:
        return "English";
    }
  };
  const translate = (key) => {
    const keys = key.split(".");
    return (
      keys.reduce((obj, keyPart) => obj?.[keyPart], translation[language]) ||
      key
    );
  };

  const handleDisconnect = () => {
    sessionStorage.removeItem("account");
    sessionStorage.removeItem("network");
    setAccount(null);
    setNetwork(null);
    toast.info(`${translate("walletDisconnected")}`);
  };

  return (
    <>
      <nav className="navbar navbar-expand-md">
        <div className="container-fluid">
          <NavLink className="navbar-brand" to="/">
            <img
              // src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1758623009/Group_102_yyrlui.svg"
              src="https://res.cloudinary.com/dbtsrjssc/image/upload/v1760447837/Group_515_bx6zst.svg"
              alt="logo"
            />
          </NavLink>{" "}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item">
                <div className="nav-link nav-explore">
                  {translate("nav.trade.heading")}
                  <ul className="hover-nav">
                    <li>
                      <NavLink className="nav-link" to="/swap">
                        <i className="fa-solid fa-retweet me-1"></i>{" "}
                        {translate("nav.trade.options.swap")}
                      </NavLink>
                    </li>
                    {/* <li>
                             <NavLink className="nav-link" to="/limit">
                               <i className="fa-solid fa-chart-simple me-1"></i> Limit
                             </NavLink>
                           </li> */}
                    <li>
                      <NavLink className="nav-link" to="/send">
                        <i className="fa-solid fa-arrow-up-from-bracket me-1"></i>{" "}
                        {translate("nav.trade.options.send")}
                      </NavLink>
                    </li>{" "}
                    <li>
                      <NavLink className="nav-link" to="/buy">
                        <i className="fa-solid fa-wallet me-1"></i>{" "}
                        {translate("nav.trade.options.buy")}
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
              {/* <li className="nav-item">
                <div className="nav-link nav-explore">
                  {translate("nav.explore.heading")}
                  <ul className="hover-nav">
                    <li>
                      <NavLink className="nav-link" to="/tokens">
                        {translate("nav.explore.options.tokens")}
                      </NavLink>
                    </li>
                    <li>
                             <NavLink className="nav-link" to="/pooltable">
                               Pool
                             </NavLink>
                           </li>
                           <li>
                             <NavLink className="nav-link" to="/transactions">
                               Transactions
                             </NavLink>
                           </li>
                  </ul>
                </div>
              </li> */}
              <li className="nav-item">
                <div className="nav-link nav-explore">
                  {translate("nav.pool.heading")}
                  <ul className="hover-nav">
                    <li>
                      <NavLink className="nav-link" to={`/pool/${account}`}>
                        {translate("nav.pool.viewPositions")}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="nav-link" to="/createPool">
                        {translate("nav.pool.createLiquidity")}
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="nav-link" to="/removeLiquidity">
                        {translate("nav.pool.removeLiquidity")}
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
            <form
              className="d-flex ms-auto mobile-ui-form"
              role="search"
              onSubmit={(e) => e.preventDefault()}
            >
              {" "}
              {/* <div
                className=" select-lang-btn"
                style={{
                  width: "max-content",
                  whiteSpace: "nowrap",
                }}
              >
                <div className="language-toggle">
                  <button
                    className={`language-button ${
                      language === "en" ? "active" : ""
                    }`}
                    onClick={() => toggleLanguage("en")}
                  >
                    EN
                  </button>
                  <button
                    className={`language-button language-btn-chinese ${
                      language === "zh" ? "active" : ""
                    }`}
                    onClick={() => toggleLanguage("zh")}
                  >
                    中
                  </button>{" "}
                  <button
                    className={`language-button language-btn-vietnamese ${
                      language === "vn" ? "active" : ""
                    }`}
                    onClick={() => toggleLanguage("vn")}
                  >
                    Việt
                  </button>
                </div>
              </div> */}
              <div
                className="select-lang-btn"
                style={{ width: "max-content", whiteSpace: "nowrap" }}
              >
                <Dropdown className="language-toggle">
                  <Dropdown.Toggle
                    variant=""
                    id="dropdown-language"
                    size="sm"
                    style={{
                      color: "#fff",
                      border: "1px solid #444444c5",
                      padding: "5px 10px",
                      fontSize: "15px",
                    }}
                  >
                    {getLanguageLabel(language)}
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="select-language-dropdown">
                    <Dropdown.Item onClick={() => toggleLanguage("en")}>
                      English
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => toggleLanguage("zh")}>
                      中文
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => toggleLanguage("vn")}>
                      Việt
                    </Dropdown.Item>{" "}
                    <Dropdown.Item onClick={() => toggleLanguage("ja")}>
                      日本語
                    </Dropdown.Item>{" "}
                    <Dropdown.Item onClick={() => toggleLanguage("ko")}>
                      한국어
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              {account ? (
                <div>
                  <button className="btn btn-connect-wallet" disabled>
                    {shortenAddress(account)}
                  </button>
                  <button
                    onClick={handleDisconnect}
                    className="btn btn-disconnect-wallet"
                    type="button"
                  >
                    <i className="fa-solid fa-right-from-bracket text-white"></i>
                  </button>
                </div>
              ) : (
                <button
                  onClick={handleConnectMetamask}
                  className="btn btn-connect-wallet"
                  type="button"
                >
                  {translate("nav.connect")}
                </button>
              )}
            </form>
          </div>
        </div>
      </nav>

      <Modal
        className="text-white"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{translate("modalTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {/* You are not on ETHW. Do you want to add it? */}
            {translate("modalBody")}
          </p>
          <ul>
            <li>
              <strong>
                {/* Network */}
                {translate("labels.network")}:
              </strong>{" "}
              {ETHW_PARAMS.chainName}
            </li>
            <li>
              <strong>
                {/* Chain ID */}
                {translate("labels.chainId")}:
              </strong>{" "}
              {parseInt(ETHW_PARAMS.chainId, 16)}
            </li>
            <li>
              <strong>
                {/* Symbol */}
                {translate("labels.symbol")}:
              </strong>{" "}
              {ETHW_PARAMS.nativeCurrency.symbol}
            </li>
            <li>
              <strong>
                {/* RPC */}
                {translate("labels.rpc")}:
              </strong>{" "}
              {ETHW_PARAMS.rpcUrls[0]}
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            {/* Cancel */} {translate("buttons.cancel")}
          </Button>
          <Button variant="primary" onClick={handleAddNetwork}>
            {/* Proceed */} {translate("buttons.proceed")}
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer theme="dark" position="top-right" />
    </>
  );
};

export default Navbar;
